export default __webpack_public_path__ + "static/media/feather _ gift.71c57353.svg";